import { AccountInfo } from '@azure/msal-common';

const getOrganizationId = (user: AccountInfo): string => {
  const { extension_organization_id } = user?.idTokenClaims ?? {};
  return extension_organization_id as string;
};

export { getOrganizationId };
